import { styled } from 'baseui'
import type { Theme } from 'baseui'

interface PulseProp {
  $pulse?: boolean
}

export const StyledPceSearchHint = styled<'div', PulseProp>('div', ({ $theme, $pulse }) => ({
  marginTop: $pulse ? '-4px' : '-0.5rem',
  marginBottom: $pulse ? '12px' : '1rem',
  fontSize: $pulse ? '12px' : '0.8rem',
  color: $pulse ? $theme.colors.textPulseMuted : $theme.colors.textMuted,
}))

export const StyledPceSearchAction = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '0.5rem',
})

export const StyledPceSearchBlockMessage = styled<'div', PulseProp>('div', ({ $theme, $pulse }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.375rem',
  width: '100%',
  maxWidth: '22rem',
  textAlign: 'left',
  fontSize: $pulse ? '12px' : '0.8rem',
  color: $theme.colors.warningText,
}))

const pillRadius = (value: string) => ({
  borderTopLeftRadius: value,
  borderTopRightRadius: value,
  borderBottomLeftRadius: value,
  borderBottomRightRadius: value,
})

export const PceSearchCountdownOverrides = {
  BarContainer: {
    style: () => ({ width: '100%', marginTop: 0, marginRight: 0, marginBottom: 0, marginLeft: 0 }),
  },
  Bar: {
    style: ({ $theme }: { $theme: Theme }) => ({
      ...pillRadius('999px'),
      width: '100%',
      height: '0.3rem',
      backgroundColor: $theme.colors.borderLight,
    }),
  },
  BarProgress: {
    style: ({ $theme }: { $theme: Theme }) => ({
      ...pillRadius('999px'),
      backgroundColor: $theme.colors.primary,
      transition: 'transform 1s linear',
    }),
  },
}

export const PulsePceSearchCountdownOverrides = {
  ...PceSearchCountdownOverrides,
  Bar: {
    style: ({ $theme }: { $theme: Theme }) => ({
      ...pillRadius('4px'),
      width: '100%',
      height: '4px',
      backgroundColor: $theme.colors.borderPulse,
    }),
  },
  BarProgress: {
    style: ({ $theme }: { $theme: Theme }) => ({
      ...pillRadius('4px'),
      backgroundColor: $theme.colors.primaryPulse,
      transition: 'transform 1s linear',
    }),
  },
}
